import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Carrier from '../../models/Carrier'

export interface CarrierListState extends PaginatedApiState {
  carriers?: Carrier[]
}

const CarrierList = (state: CarrierListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<CarrierListState>('CARRIER_LIST')(state, action)
  }
}

export default CarrierList
